export default "__VITE_ASSET__DHym_d6t__"